import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "card-header"
};
const _hoisted_2 = {
  class: "card-header-title"
};
export default {
  __name: 'CardHeader',
  props: {
    title: {
      type: String,
      default: '评价'
    }
  },
  setup(__props) {
    let prop = __props;
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(prop).title), 1), _createVNode(_component_el_image, {
        class: "card-header-img",
        src: require('@/assets/images/screen/header_line.png'),
        fit: "contain"
      }, null, 8, ["src"])]);
    };
  }
};